import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

export type FilterChipLabelProps = {
  label: string;
  value?: string;
  isLoading?: boolean;
};

export const FilterChipLabel: React.FC<FilterChipLabelProps> = ({ label, value, isLoading }) => {
  if (!value && isLoading) {
    return (
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
        {`${label}:`}
        <Skeleton height={12} sx={{ transform: 'none' }} variant="text" width={100} />
      </Box>
    );
  }

  return <>{`${label}: ${value || '—'}`}</>;
};
